import { loadDeferredComponentStyles, prefetchDeferredComponentStyles } from '@theme/deferred-styles';

/** @type {Array<[string, string]>} */
const prefetchTargets = [
  ['header-drawer summary', 'headerDrawer'],
  ['cart-drawer-component summary, [data-testid="cart-drawer-trigger"]', 'cartDrawer'],
  ['[data-search-modal-opener]', 'searchModal'],
  ['.header-menu .menu-list__link, .header-menu .overflow-menu', 'headerMegaMenu'],
  ['quick-add-component, .quick-add__button', 'quickAddModal'],
  ['a[href="#newsletter-popup"], [data-newsletter-popup-trigger]', 'newsletterPopup'],
];

function setupPrefetch() {
  for (const [selector, key] of prefetchTargets) {
    document.querySelectorAll(selector).forEach((element) => {
      element.addEventListener('pointerenter', () => prefetchDeferredComponentStyles(key), {
        once: true,
        passive: true,
      });
      element.addEventListener('focusin', () => prefetchDeferredComponentStyles(key), {
        once: true,
      });
    });
  }
}

function prefetchOnIdle() {
  const idle = /** @type {(callback: () => void) => void} */ (
    window.requestIdleCallback ?? ((callback) => setTimeout(callback, 1200))
  );

  idle(() => {
    prefetchDeferredComponentStyles('headerMegaMenu');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      setupPrefetch();
      prefetchOnIdle();
    },
    { once: true }
  );
} else {
  setupPrefetch();
  prefetchOnIdle();
}
